var collapsible_list_component_rtlignore_default = {
  "ltr": "_9xh3k",
  "rtl": "FA40p",
  "iconContainer": "_1c1ME",
  "icon": "FqqCO",
  "isExpanded": "BT39e",
  "listDimensions": "Okn4c"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
